import type { UpdateStoreMethod } from '@aytm/app/insights/dashboard/components/hooks/useDashboard/types'
import { makeFetchAccessKeyAction } from '@aytm/app/insights/dashboard/duckness/ducks/AccessKeyDuck/AccessKeyDuck.actionCreators'
import {
  makeClonePortalDashboardAction,
  makeDismissShareDialogDashboardAction,
  makeRequestShareURLDashboardAction,
  makeSendInvitationForEmailDashboardAction,
  makeSendInvitationResetStatusDashboardAction,
  makeSendSchemaRequestDashboardAction,
  makeSendSourceRequestDashboardAction,
  makeUpdateDashboardDashboardAction
} from '@aytm/app/insights/dashboard/duckness/ducks/DashboardDuck/DashboardDuck.actionCreators'
import { makeUpdateDataPortalAction } from '@aytm/app/insights/dashboard/duckness/ducks/PortalDuck/PortalDuck.actionCreators'
import type { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { poolDispatch } from '@aytm/app/insights/dashboard/duckness/poolDispatch'
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

export const updateStore: UpdateStoreMethod = updates => poolDispatch(makeUpdateDataPortalAction(updates))
// InsightsDashboardPool.dispatch(PortalDuck.duckName, PORTAL_ACTIONS.UPDATE_DATA, updates)

export const fetchAccessKey = () => {
  poolDispatch(makeFetchAccessKeyAction(staticStore.currentSharedKey))
  // InsightsDashboardPool.dispatch(
  //   AccessKeyDuck.duckName,
  //   // 'stat-query',
  //   ACCESS_KEY_ACTIONS.FETCH_ACCESS_KEY, //'fetchAccessKey',
  //   { sharedKey: staticStore.currentSharedKey }
  // )
}

export const updateDashboard = (update: Partial<InsightsDashboardPoolState>) => {
  poolDispatch(makeUpdateDashboardDashboardAction(update))
  // InsightsDashboardPool.dispatch('dashboard', DASHBOARD_ACTIONS.UPDATE_DASHBOARD, update)
}

export const clonePortal = ({ title = 'Insights' } = {}) => {
  poolDispatch(makeClonePortalDashboardAction(title))
  // InsightsDashboardPool.dispatch('dashboard', DASHBOARD_ACTIONS.CLONE_PORTAL, {
  //   title
  // })
}

export const dismissShareDialog = () => {
  poolDispatch(makeDismissShareDialogDashboardAction())
  // InsightsDashboardPool.dispatch('dashboard', DASHBOARD_ACTIONS.REQUEST_SHARE_UI, null)
}

export const requestShareURL = (reportId: string) => {
  poolDispatch(makeRequestShareURLDashboardAction(reportId))
  // InsightsDashboardPool.dispatch('dashboard', DASHBOARD_ACTIONS.REQUEST_SHARE_URL, reportId)
}

export const sendInvitationLink = (sharedKey?: string, email?: string | string[], sendStatusReset?: boolean) =>
  sendStatusReset
    ? poolDispatch(makeSendInvitationResetStatusDashboardAction())
    : poolDispatch(makeSendInvitationForEmailDashboardAction(email, sharedKey))

export const sendSource = (input: object) => {
  // Send source to aytm server
  poolDispatch(makeSendSourceRequestDashboardAction(input))
}

export const sendSchema = (input: object) => {
  // Send source to aytm server
  poolDispatch(makeSendSchemaRequestDashboardAction(input))
}
